export default __webpack_public_path__ + "8962401d46d01ed19f8e8b6862b4e3b8.ttf";